__turbopack_context__.v({
  "container": "MobileMenu-module__jabnyW__container",
});
